export interface Breadcrumb {
    title: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    link?: string | any[];
}
